import createSimpleComponent from '../createSimpleComponent'

import cls from './empty-state.module.scss'

export default createSimpleComponent({
  displayName: 'EmptyStateBox',
  className: cls.wrapper,
  Component: 'div',
})
